export const waitForElasticConnection = (getState) => {
    return new Promise((resolve, reject) => {
      const startTime = Date.now();
      const timeoutMs = 10000;
      const checkConnection = () => {
        const isElasticConnected = getState().allStatesData?.isElasticConnected;
        if (isElasticConnected !== "pending") {
          resolve(!!isElasticConnected); 
        } else if (Date.now() - startTime > timeoutMs) {
          reject(new Error("Elastic connection check timed out"));
        } else {
          setTimeout(checkConnection, 100);
        }
      };
      checkConnection();
    });
  };